<div class="container">
  <div class="text-center">
    <h5 class="display-5 mt-3 mb-5">My Queries</h5>
  </div>

  <hr>

  <div class="my-5" *ngIf="isQueriesLoading == true" style="width: 100%; display: flex; align-items: center; justify-content: center;">
    <div class="loader"></div>
    <div>
      Loading Queries...
    </div>
  </div>

  <div *ngIf="isQueriesLoading == false">
    <a
    *ngFor="let query of queryList"
    style="cursor: pointer;"
    data-toggle="modal"
    data-target="#queryDetailsModal"
    (click)="onSelectQuery(query._id)">
    <div class="query text-center p-3 mb-3">
      <div class="row">
        <div class="col-md-4" style="font-weight: 550;">
          {{ query.fullName }}
        </div>
        <div class="col-md-4">
          {{ query.email }}
        </div>
        <div class="col-md-4">
          {{ query.createdAt | date: 'dd MMM, hh:MM a' }}
        </div>
      </div>
    </div>
  </a>
  </div>
</div>

<!-- Details Modal -->
<div class="modal fade" id="queryDetailsModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">{{ selectedQuery.fullName }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-4" style="text-align: right;">
            <p style="font-weight: bold;">Name:</p>
          </div>
          <div class="col-8">
            <p>{{ selectedQuery.fullName }}</p>
          </div>

          <div class="col-4" style="text-align: right;">
            <p style="font-weight: bold;">Email:</p>
          </div>
          <div class="col-8">
            <p>{{ selectedQuery.email }}</p>
          </div>

          <div class="col-4" style="text-align: right;">
            <p style="font-weight: bold;">Contact:</p>
          </div>
          <div class="col-8">
            <p>{{ selectedQuery.mobileNumber }}</p>
          </div>

          <div class="col-4" style="text-align: right;">
            <p style="font-weight: bold;">Date:</p>
          </div>
          <div class="col-8">
            <p>{{ selectedQuery.createdAt | date: 'dd MMM yyyy, hh:MM a' }}</p>
          </div>

          <div class="col-4" style="text-align: right;">
            <p style="font-weight: bold;">Subject:</p>
          </div>
          <div class="col-8">
            <p>{{ selectedQuery.subject }}</p>
          </div>

          <div class="col-4" style="text-align: right;">
            <p style="font-weight: bold;">Message:</p>
          </div>
          <div class="col-8">
            <p>{{ selectedQuery.message }}</p>
          </div>

          <div class="col-4" style="text-align: right;">
            <p style="font-weight: bold;">Attached File:</p>
          </div>
          <div class="col-8" *ngIf="selectedQuery.attachFile">
            <div class="received_withd_document" (click)="downloadDocument(selectedQuery)">
              <button
                type="button"
                class="btn btn-sm btn-outline-dark"
                *ngIf="selectedQuery.attachFile[0]">
                  {{selectedQuery.attachFile[1]}} <i class="fa fa-download"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
